
export const resolveExtras = (page = undefined, perpage = undefined, deleted = undefined) => {
    return ['$stateParams', 'extrasService', ($stateParams, extrasService) => {
        if (!$stateParams.filtertext) {
            return extrasService.findAll(page, perpage, deleted).then(list => list);
        }

        return extrasService.search('name', $stateParams.filtertext, page).then(list => list);
    }];
};

export const resolveExtra = (param = 'extra') => {
    return ['$stateParams', 'extrasService', ($stateParams, extrasService) => {
        return $stateParams[param] && $stateParams[param] > 0 ? extrasService.findById($stateParams[param]) : {};
    }];
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/resolvers/extras.resolver.js